import {Link, useHistory} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {constants, customStyles} from "../../utils/constants";
import moment from "moment";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import swal from "sweetalert";
import {Button, Col, Dropdown, DropdownButton, FormControl, InputGroup, Row} from "react-bootstrap";
import {AddIconOutline, MenuDots, SearchIcon} from "../../components/SvgIcons";
import DataTable from "react-data-table-component";
import BarLoader from "react-spinners/BarLoader";
import {DeleteBadge, GetBadges} from "../../services/badges.service";
import DataTableExtensions from "react-data-table-component-extensions";
import {EmptyState} from "../../components/EmptyState";

function Badges() {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(constants.PERPAGE);
    const [rows, setRows] = useState();
    const [keyword, setKeyword] = useState('');

    useEffect(async () => {
        await  getBadges();
    }, [keyword, page, perPage])

    const getBadges = async () => {
        setLoading(true)
        await GetBadges(keyword,page, perPage,).then((result) => {
            if (result.status) {
                if (result.data) {
                    const rowData = [];
                    setTotalRows(result.data.length);
                    let counter = 1; // Initialize the counter to start from 1
                    result.data.data.map((dt, index) => {
                        rowData.push({
                            sno: counter++,
                            _id:dt._id || '-',
                            title: dt.title || '-',
                            image: dt.image || 'noimage.jpg',
                            type: dt.type || '-',
                            count: dt.count || '-',
                            created_at: moment(dt.created_at).fromNow(),
                        });
                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                setRows([]);
                return toast.error(result.message);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.message);
            }
        })
    }

    const caseInsensitiveNameSort = (rowA, rowB) => {

        const a = rowA.title.toLowerCase();
        const b = rowB.title.toLowerCase();
        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };


    const onBadgeDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this badge?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {
            //Delete  API
            if (willShip) {
                await DeleteBadge(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getBadges();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onEdit = (data) => {
        // console.log( data._id)
        history.push('/badges/edit-badge/' + data._id, {
            data: data
        });
    }

    const userActions = (data) => {

        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onEdit(data)}>Edit</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onBadgeDelete(data._id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }

    const columns = [
        {
            id: 'sno',
            name: 'ID',
            center: true,
            sortable: false,
            selector: rowData => rowData.sno,
            cellExport: rowData => rowData.sno,
        },
        {
            id: 'title',
            name: 'Name',
            sortable: true,
            center: true,
            selector: rowData => rowData.title,
            cellExport: rowData => rowData.title,
            sortFunction: caseInsensitiveNameSort
        },
        {
            id: 'image',
            name: 'Image',
            center: true,
            cell: (rowData) => <img src={rowData.image} alt={rowData.name} style={{ width: '50px', height: '50px' }} />,
            selector: rowData => rowData.profileImage,
            cellExport: rowData => rowData.profileImage,
        },
        {
            id: 'type',
            name: 'Type',
            center: true,
            selector: rowData => rowData.type,
            cellExport: rowData => rowData.type,
        },
        {
            id: 'count',
            name: 'Count',
            center: true,
            selector: rowData => rowData.count,
            cellExport: rowData => rowData.count,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
            cellExport: rowData => rowData.created_at,
        },
        {
            id: 'action',
            name: 'Action',
            center: true,
            cell: rowData => userActions(rowData),
            export: false
        },
    ];

    return (
        <div className={"usersPage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Badges</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>

                    <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        {/*{rows && rows.length > 0 ? (*/}
                            <InputGroup className="mb-3 search-group">
                                <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                                <FormControl
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="Search"
                                    maxLength={"255"}
                                    onChange={(e) => {
                                        (e.target.value.length > 2) ? setKeyword(e.target.value) : setKeyword(null)
                                    }}
                                />
                            </InputGroup>
                        {/*) : ('')}*/}
                    </Col>

                    <Col xs={12} sm={12} md={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 2 }} xl={{ span: 2, offset: 2 }}>

                    </Col>

                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Link to={"/badges/add-badge"}>
                            <Button className={"btn btn-green-theme h40 w-100"}>
                                <AddIconOutline /> Add New
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </div>

            <div className="theme-dataGrid products-dataGrid">
                {rows && rows.length == 0 ? (
                    <EmptyState/> // Render the EmptyState component when there are no records
                ): (
                <DataTableExtensions
                    columns={columns}
                    data={rows}
                    filter={false}
                    print={false}
                    exportHeaders
                    fileName='Badges'
                >
                <DataTable
                    pagination
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover
                    persistTableHead
                    paginationServer
                    paginationTotalRows={totalRows}
                    // paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#f39633'} loading={loading} css={'marginTop: 10px'}
                                                  height={'4'} width={'100%'} />}
                />
                </DataTableExtensions>

                )}
            </div>
        </div>
    )
}

export default Badges